import React from 'react'
import {faCircleArrowRight} from '@fortawesome/free-solid-svg-icons/faCircleArrowRight'
import {Color} from '../../Styles'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import Black = Color.Black

export const MemberCircleArrowRightIcon: React.VFC = () => {
  return <FontAwesomeIcon icon={faCircleArrowRight} size={'lg'} color={Black}/>
}
